export type BubbleImageLoadTimes = {
	bubbleImageLoadStartTime?: number;
	bubbleImageLoadEndTime?: number;
};

export type CompletedBubbleImageLoadTimes = {
	bubbleImageLoadStartTime: number;
	bubbleImageLoadEndTime: number;
};

export const isBubbleImageLoadPending = (metrics: BubbleImageLoadTimes): boolean =>
	metrics.bubbleImageLoadStartTime != null && metrics.bubbleImageLoadEndTime == null;

export const isBubbleImageLoadComplete = (
	metrics: BubbleImageLoadTimes,
): metrics is CompletedBubbleImageLoadTimes =>
	metrics.bubbleImageLoadStartTime != null && metrics.bubbleImageLoadEndTime != null;
